// @mui
import { List, Stack } from '@mui/material';
import { useAuthContext } from '../../../auth/useAuthContext';
// locales
import { useLocales } from '../../../locales';
import { hasPermission } from '../../../utils/permissions';
//
import { NavSectionProps } from '../types';
import NavList from './NavList';
import { StyledSubheader } from './styles';

// ----------------------------------------------------------------------

export default function NavSectionVertical({
  data,
  sx,
  ...other
}: NavSectionProps) {
  const { translate } = useLocales();
  const { user } = useAuthContext();

  return (
    <Stack sx={sx} {...other}>
      {data.map((group) => {
        if (group.permission && !hasPermission(user, group.permission)) {
          return <></>;
        }

        const key = group.subheader || group.items[0].title;

        return (
          <List key={key} disablePadding sx={{ px: 2 }}>
            {group.subheader && (
              <StyledSubheader disableSticky>{`${translate(
                group.subheader
              )}`}</StyledSubheader>
            )}

            {group.items.map((list) => (
              <NavList
                key={list.title + list.path}
                data={list}
                depth={1}
                hasChild={!!list.children}
              />
            ))}
          </List>
        );
      })}
    </Stack>
  );
}
